<template>
  <div class="contact">
    <div class="jumbotron jumbotron-fluid text-center">
      <div class="container">
        <img class="icons" src="@/assets/iconos/phone-call.png"/>
        <h1 class="display-4">¿Tienes dudas, contáctanos?</h1>
        <a class="lead" href="tel:8181300005">81 81 30 00 05</a>
        <br>
        <a class="lead" href="tel:8008371997">800 837 1997</a>
         <br>
        <a class="lead" href="tel:8113541003">81 13 54 10 03</a>
         <br>
        <a class="lead" href="tel:8113541005">81 13 54 10 05</a>
        <p class="lead text-muted" style="font-size: 1rem;">En un horario de 08:00 a 16:00 horas</p>
        <p class="lead text-muted" style="font-size: 1rem;">De lunes a viernes</p>
      </div>
    </div>

    <div id="contact-form" class="row">
      <p class="contact-heading text-uppercase text-center">
        O déjanos tus datos
      </p>
      <div class="card">
        <div class="card-body">
          <div class="card-text">

      <p v-if="errors.length" class="form-errors">
          <b>Se presentaron los siguientes errores:</b>
          <ul>
            <li v-for="(error, index) in errors" v-bind:key="index">{{ error }}</li>
          </ul>
        </p>

            <form @submit="CheckForm">
              <div class="form-group">
                <label for="form_nombreCompleto">Nombre completo</label>
                <input
                  type="text"
                  class="form-control"
                  id="form_nombreCompleto"
                  v-model="form.formNombreCompleto"
                  autocomplete="off"
                />
              </div>

              <div class="form-group">
                <label for="form_telefono">Teléfono:</label>
                <input
                  type="text"
                  class="form-control"
                  id="form_telefono"
                  minlength="10"
                  maxlength="10"
                  v-model="form.formTelefono"
                  @keypress="validateNumber"
                  autocomplete="off"
                />
              </div>

              <div class="form-group">
                <label for="form_correo">Correo:</label>
                <input
                  type="email"
                  class="form-control"
                  id="form_correo"
                  v-model="form.formCorreo"
                  autocomplete="off"
                />
              </div>

              <div class="form-group">
                <label for="form_detallesCaso">Detalles del caso:</label>
                <textarea
                  rows="3"
                  class="form-control"
                  id="form_detallesCaso"
                  v-model="form.formDetalles"
                  maxlength="500"
                />
                <span id="limiter">{{charsLeft}}</span>
              </div>

              <div class="form-check form-switch" style="margin-top: 8px; margin-bottom: 16px;">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="form_valoracionMedico"
                  v-model="form.formValoracionMedica"
                />
                <label for="form_valoracionMedico" class="form-check-label">¿Se cuenta con valoración de un médico?</label>
              </div>



            <section style="margin: 8px; text-align: -moz-center; text-align: -webkit-center;">
              <vue-recaptcha 
              sitekey="6LcN1f0dAAAAANZ5L4OZoQocAeM-DOhmR31fHmXd"
              @verify="ChangeRecaptchaToValid()"
              @expired="ChangeRecaptchaToInvalid()"
              @error="ChangeRecaptchaToInvalid()"
              language="es" >
            </vue-recaptcha>
            </section>


              <div class="form-group">
                <br>
                <button type="submit" class="btn btn-gob-blue btn-form">
                  <span class="mdi mdi-send"></span> Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>
.jumbotron {
  padding: 16px;
  margin: 16px;
  min-height: 20vh;
}

.jumbotron .lead {
  font-size: 1.6rem;
  font-weight: bold;
  color: black;
  text-decoration: none;
}

#contact-form {
  background-color: #cfd8dc; /* Material Blue Grey 100*/
  padding: 16px;
}

.contact-heading {
  font-size: 1.6rem;
  margin-top: 32px;
  margin-bottom: 32px;
}

.card {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 32px;
  border-radius: 16px;
  padding: 16px;
  max-width: 80%;
}

.form-errors {
  background-color: #c62828; /* Material Red 800 */
  border-radius: 16px;
  padding: 16px;
  color: #fafafa;
}

.icons {
  width: 48px;
}

.form-group {
  padding: 8px;
}

.btn-form {
  width: 100%;
  padding: 16px;
}

#limiter {
  display: none;
  float: right;
  font-size: 0.9rem;
}
</style>

<script>
import axios from "axios";
import { VueRecaptcha } from "vue-recaptcha";

let axiosConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

export default {
  name: "Contact",
  components: { VueRecaptcha },
  data() {
    return {
      errors: [],
      isRecaptchaSolved: false,
      form: {
        formNombreCompleto: "",
        formTelefono: "",
        formCorreo: "",
        formDetalles: "",
        formValoracionMedica: false,
      },
    };
  },
  methods: {
    ShowAlert(title, message, icon) {
      this.$swal({
        title: title,
        text: message,
        type: icon,
      }).then((result) => {
        if (result.isConfirmed) {
          this.clearModel();
        }
      });
    },

    submitForm() {
      var bodyFormData = new FormData();
      bodyFormData.append("formNombreCompleto", this.form.formNombreCompleto);
      bodyFormData.append("formTelefono", this.form.formTelefono);
      bodyFormData.append("formCorreo", this.form.formCorreo);
      bodyFormData.append("formDetalles", this.form.formDetalles);
      bodyFormData.append(
        "formValoracionMedica",
        this.form.formValoracionMedica
      );
      bodyFormData.append("formUserAgent", this.getUserAgent);

      axios
        .post(
          "https://saludnl.gob.mx/apis/cancermama/v1/cmama_service.php/",
          bodyFormData,
          axiosConfig
        )
        .then(() => {
          console.info("SUCCESS SEND");
          this.ShowAlert("Exito", "Tu información ha sido enviada.", "success");
        })
        .catch((error) => {
          console.info("ERROR SEND");
          this.ShowAlert(
            "Error",
            "Intenta enviar tu información nuevamente, [" + error + "`]",
            "error"
          );
        })
        .finally(() => {
          //Perform action in always
        });
    },

    CheckForm(e) {
      this.errors = [];

      // Validate formNombreCompleto
      if (
        this.form.formNombreCompleto == null ||
        this.form.formNombreCompleto === ""
      ) {
        this.errors.push("Nombre no debe estar vacio");
      }

      // Validate formCorreo
      if (!this.form.formCorreo) {
        this.errors.push("El correo electrónico es obligatorio.");
      } /*else if (!this.validEmail(this.form.formCorreo)) {
        this.errors.push('El correo electrónico debe ser válido.');
      }*/

      if (this.form.formValoracionMedica) {
        this.form.formValoracionMedica = 1;
      } else {
        this.form.formValoracionMedica = 0;
      }

      // Validate ReCaptcha
      if (!this.isRecaptchaSolved) {
        this.errors.push("Por favor, confirma que no eres un robot.");
      }

      // Check if errors exists
      //console.info("ArrayErrors Lenght: " + this.errors.length);
      if (this.errors.length == 0) {
        this.submitForm();
      } else {
        console.info("Hay errores");
      }

      e.preventDefault();
    },

    /*validEmail:function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }*/

    clearModel() {
      this.form.formNombreCompleto = "";
      this.form.formTelefono = "";
      this.form.formCorreo = "";
      this.form.formDetalles = "";
      this.form.formValoracionMedica = false;
      this.form.formUserAgent = "";
    },
    ChangeRecaptchaToValid() {
      this.isRecaptchaSolved = true;
    },
    ChangeRecaptchaToInvalid() {
      this.isRecaptchaSolved = false;
    },
    validateNumber(event) {
      const charCode = String.fromCharCode(event.keyCode);
      if (!/[0-9]/.test(charCode)) {
        event.preventDefault();
      }
    },
  },

  computed: {
    getUserAgent: function () {
      return navigator.userAgent;
    },
    charsLeft: function () {
      var charOnTextArea = this.form.formDetalles.length;
      var limit = 500;
      var limiterObject = document.getElementById("limiter");

      var chars = limit - charOnTextArea;

      if (limiterObject != null) {
        if (chars <= 100) {
          limiterObject.style.display = "block";
        } else {
          limiterObject.style.display = "none";
        }
      }

      return chars + " caracteres restantes.";
    },
  },
};
</script>
